<div class="about-me">
    <section>
        <h2>About Me</h2>
        <p>
            I am a Computer Science Graduate, from Ahmedabad University and a
            Software Engineer by profession. I spend the other half of time into
            Competitive Programming, Machine Learning, and AI.
        </p>
    </section>
</div>

<style>
    .about-me {
        display: flex;
        /* margin: 0 300px; */
    }
    section {
        padding: 20px;
    }

    h2 {
        display: flex;
        font-size: 2.5rem;
        color: tomato;
        margin-bottom: 10px;
        border-bottom: 5px solid var(--border-color);
    }

    p {
        color: var(--about-me-color) white;
        font-size: 2.1rem;
        margin-bottom: 1px;
    }
</style>
